import Api from '@/util/Api'

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új beutaló rögzítése',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeRow'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: 'interReferralEditButtonVisibility',
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: 'internalReferralDeleteButtonVisibility',
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Beutaló sorszáma",
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "doctorName",
                label: "Beutaló orvos",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formRequired: true,
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "organizationUnitName",
                label: "Beutaló orvos szakmája",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "text",
                formSize: 3
            },
            {
                name: "treatmentName",
                label: "Kért vizsgálat",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "text",
                formSize: 3,
            },
            {
                name: "referralDate",
                label: "Beutalás ideje",
                slot_name: "referral_format",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "text",
                formSize: 3
            },
            {
                name: "referralStatus",
                label: "Felhasználva",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "text",
                formSize: 3
            },
            {
                name: "imageDiagnosticsDetail",
                label: "Képdiagnosztika részletezése",
                visibility: true,
                formVisible: true,
                viewModalShow: true,
                formType: "text",
                formColSize: 6
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: true,
                formVisible: true,
                formType: "textarea",
                viewModalShow: true,
                formSize: 9,
                formColSize: 6
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        searchFields: [
            {
                name: "referralId",
                label: "Beutaló sorszáma",
                formVisible: false
            },
            {
                name: "name",
                label: "Beutaló orvos",
                formVisible: true,
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "vaccine",
                label: "Beutaló orvos szakmája",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "occupationalIndication",
                label: "Kért vizsgálat",
                formType: "text",
                formSize: 4,
                formVisible: true
            },
            {
                name: "dosage",
                label: "Megjegyzés",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                name: "basicImmunization",
                label: "Beutalás ideje",
                formType: "date",
                formSize: 4,
                formVisible: true
            },
            {
                name: "boosterVaccination",
                label: "Felhasználva",
                formType: 'select', 
                formSize: 4,
                formVisible: true,
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'Felhasználás dátuma',
                        },
                        {
                            id: "2",
                            text: 'Nem került felhasználásra',
                        },
                        {
                            id: "3",
                            text: 'Lejárt',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ]
    }
}
